import * as React from 'react';
import SenderSubjectFull from './components/SenderSubjectFull';
import discardSenderSubjectOption from './actions/discardSenderSubjectOption';
import saveSenderSubjectOption from './actions/saveSenderSubjectOption';
import isSenderSubjectOptionDirty from './utils/isSenderSubjectOptionDirty';
var SenderSubjectOption = {
    key: 'senderSubject',
    titleStringKey: 'optionTitle_senderSubjectOrder',
    searchTermsStringKey: 'optionTitle_senderSubjectOrder',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SenderSubjectFull, null); },
        isDirty: isSenderSubjectOptionDirty,
        onSave: saveSenderSubjectOption,
        onDiscard: discardSenderSubjectOption,
    },
};
export default SenderSubjectOption;
//# sourceMappingURL=SenderSubjectOption.js.map